/**
 * @export
 * @class HotelBenefit
 * 구매혜택(투어)
 *  - 부킹닷컴 예약하기로 이동
 *  - test deal: 671958342
 */
export default class HotelBenefit {
  constructor() {
    const { contentInfo } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;

    if (contentInfo && contentInfo.eanpkgYn === true) {
      this.welWrapper = $('#_wrapHotelBenefit');
      this.setEvent();
      this.render();
    }
  }

  setEvent() {
    const {
      eanpkgKeyword,
    } = TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentInfo;
    const sUrl = `${TMON.htLocal.htURL.search}/search/linkage/booking?keyword=${eanpkgKeyword}&destType=city&searchType=search`;

    $('body').on('click', '[data-role=openHotelBenefit]', () => {
      if (!TMON.bLogin) {
        TMON.oApp.oUtil.login(sUrl, '', true);
        return;
      }
      // TODO: callApp isModal, isNeedLogin, isNeedNavigation은 정확한 값 확인 필요
      if (TMON.oApp.sPlatform === 'MA') {
        TMON.app.callApp(
          'webview',
          'showNaviWebView',
          '호텔 예약', // title
          TMON.util.aup(sUrl, TMON.sAppQuery), // sUrl
          true, // isModal
          true, // isNeedLogin
          true // isNeedNavigation
        );
        return;
      }
      window.open(sUrl, '_blank');
    });
  }

  clearEvent() {
    if (TMON.view_mode === 'app') {
      $('body').off('click', '[data-role=openHotelBenefit]');
    }
  }

  render() {
    const {
      eanpkgKeyword,
    } = TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentInfo;

    const sHTML = `<h3 class="tit_align_left">구매혜택</h3>
            <div class="ct">
                <button type="button" class="another_view" data-tlarea="MDDIA" data-tlord="5" data-role="openHotelBenefit">
                    <p>${eanpkgKeyword} 특가 호텔 (적립금 혜택)</p>
                </button>
            </div>`;

    this.welWrapper.removeClass('ct_empty').html(sHTML);
  }
}
